<script setup lang="ts">
interface ButtonIconProps {
  icon: 'arrow-left' | 'arrow-right' | 'chevron-down' | 'chevron-left' | 'chevron-right' | 'chevron-up' | 'close'
  as?: 'button' | 'span'
}

const props = withDefaults(defineProps<ButtonIconProps>(), {
  as: 'button',
})
</script>

<template>
  <Anchor
    :as="props.as"
    :type="props.as === 'button' ? 'button' : undefined"
    class="buttonIcon c-current inline-block cursor-pointer"
  >
    <span
      class="motion-snug rounded inline-flex size-9 items-center justify-center @hover:bg-current/10 focus-within:bg-current/10"
    >
      <i
        class="size-7 icon"
        :class="`i-icon-${icon}`"
        aria-hidden="true"
      />
    </span>
  </Anchor>
</template>
